module.exports = __webpack_public_path__ + "static/media/fondo-perfil-html.119c3267.jpg";